import { EyeIcon, PencilEdit02Icon } from '@/icons';
import { Flex } from 'antd';
import { useGetAllSimplifiedPoliciesQuery } from '@/app/features/control-panel/policies/policies.api';
import CustomTable from '@/components/CustomTable';
import StatusTag from '@/components/StatusTag';
import {
  DISCLOSER_KEYS,
  FILTER_KEYS,
} from '@/constants/keys.constants';
import { useAppDiscloser, useAppFilters } from '@/hooks';
import type { ColumnsType } from '@/types/global.types';
import { addUniqueKey } from '@/utils/global.utils';
import { normalizeColumnValue } from '@/utils';
import ManageLeavePolicy from './_components/Leave/ManageLeavePolicy';

const LEAVE_STATUS_CONFIG = [
  { label: 'Active', value: 'active', className: 'status status-success' },
  { label: 'Inactive', value: 'inactive', className: 'status status-error' },
];

const Leave = () => {
  const { page, skip, limit, filters, handlePagination } = useAppFilters(
    FILTER_KEYS.POLICIES_LEAVE,
  );
  const [config, handleOpen, handleClose] = useAppDiscloser(
    DISCLOSER_KEYS.POLICIES_LEAVE,
  );

  // Fetch leave policies
  const {
    data: policiesData,
    isLoading,
    isFetching,
  } = useGetAllSimplifiedPoliciesQuery({
    params: {
      skip,
      limit,
      ...filters,
    },
  });

  const columns: ColumnsType<any> = [
    {
      title: 'Policy Name',
      dataIndex: 'policy_name',
      render: (value) => normalizeColumnValue(value, 'N/A'),
    },
    {
      title: 'Office',
      dataIndex: 'office_name',
      render: (value) => normalizeColumnValue(value, 'N/A'),
    },
    {
      title: 'Leave Types Count',
      dataIndex: 'leave_type_count',
      render: (value) => normalizeColumnValue(value, 'N/A'),
    },
    {
      title: 'Active Leave Type',
      dataIndex: 'active_leave_type_count',
      render: (value) => normalizeColumnValue(value, 'N/A'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      render: (status: string) => (
        <StatusTag value={status} config={LEAVE_STATUS_CONFIG} />
      ),
    },
    {
      width: 130,
      title: 'Action',
      render: (record) => (
        <Flex gap={11}>
          <button
            onClick={() => {
              handleOpen({ type: 'VIEW', data: record });
            }}
            className="cursor-pointer"
          >
            <EyeIcon size={20} className="text-white" />
          </button>
          <button
            onClick={() => {
              handleOpen({ type: 'UPDATE', data: record });
            }}
            className="cursor-pointer"
          >
            <PencilEdit02Icon size={20} className="text-white" />
          </button>
          {/* <button className="cursor-pointer">
            <CopyIcon className="text-white text-xl" />
          </button>
          <button className="cursor-pointer">
            <ArchiveArrowUpIcon className="text-white text-lg" />
          </button> */}
        </Flex>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <CustomTable
        page={page}
        limit={limit}
        total={policiesData?.data?.meta?.total || 0}
        tableRootClassName="border-0 p-0"
        columns={columns}
        dataSource={addUniqueKey(policiesData?.data?.data || [])}
        onPaginate={handlePagination}
        loading={isLoading || isFetching}
        hideRowSelect
      />
      <ManageLeavePolicy
        open={config.open}
        type={config.type}
        id={config?.data?.id}
        handleClose={handleClose}
      />
    </div>
  );
};

export default Leave;
